export const msalConfig = {
  auth: {
    clientId: '10f4764a-3200-4c62-bd70-f8a40443f6d8',
    authority:
      'https://login.microsoftonline.com/3ae1712c-e12b-4daf-be55-959436b436d5', // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // console.error(`${level} ${message}`);
      },
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com',
};
